import { IAbortControllerFactory, IUrlService, ServerSentEventsConsumerFactory } from '..';
import { HeadersGetter } from '../httpClient/IHttpClientConfig';
import type {
    IServerSentEventsConsumerFactory,
    IServerSentEventsFactoryCreator,
} from './IServerSentEventsConsumerFactory';

export class ServerSentEventsFactoryCreator implements IServerSentEventsFactoryCreator {
    constructor(
        private urlService: IUrlService,
        private abortControllerFactory: IAbortControllerFactory,
        private headersGetter?: HeadersGetter,
    ) {}

    createFactory(baseUrl: string): IServerSentEventsConsumerFactory {
        const url = this.urlService.createUrl(baseUrl);
        return new ServerSentEventsConsumerFactory(
            url,
            this.abortControllerFactory,
            this.headersGetter,
        );
    }
}
